<script setup>
import { defineProps } from 'vue';

import IconClose01 from '@/components/svg/IconClose01.vue';
import IconPrev02 from '@/components/svg/IconPrev02.vue';
import IconNext02 from '@/components/svg/IconNext02.vue';
import IconList from '@/components/svg/IconList.vue';

// props 정의
const props = defineProps({
  items: {
    type: Array,
    required: true,
  },
  curPage: {
    type: Number,
    required: true,
  },
  lastPage: {
    type: Number,
    default: null,
  },
  hideToc: {
    type: Boolean,
    default: false,
  },
  disablePrev: {
    type: Boolean,
    default: false,
  },
  loopToFirst: {
    type: Boolean,
    default: false,
  },
  hasPermission: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits(['updateIndexNo', 'goToOverView']);

// 실제 페이지 수 (lastPage가 있으면 사용, 없으면 items.length)
const totalPages = computed(() => props.lastPage ?? props.items.length);

const goPage = (id, tocIdx) => {
  let no = id;
  if (id <= 0) {
    if (props.disablePrev) return;
    emit('goToOverView');
  }
  if (id > totalPages.value) {
    if (props.loopToFirst) {
      emit('updateIndexNo', 1, 0);
      return;
    }
    emit('goToOverView');
    return;
  }
  emit('updateIndexNo', no, tocIdx);
};

// 키보드 이벤트 핸들러
const handleKeydown = (event) => {
  if (event.key === 'ArrowLeft') {
    goPage(props.curPage - 1);
  }
  if (event.key === 'ArrowRight') {
    goPage(props.curPage + 1);
  }
};

// 컴포넌트가 마운트될 때 이벤트 리스너 추가
onMounted(() => {
  window.addEventListener('keydown', handleKeydown);
});

// 컴포넌트가 언마운트될 때 이벤트 리스너 제거
onBeforeUnmount(() => {
  window.removeEventListener('keydown', handleKeydown);
});

const openFlag = ref('');
const openContentsList = (val) => {
  openFlag.value = val;
};

const formatPageNumber = (pageNumber) => {
  return String(pageNumber).padStart(2, '0');
};
</script>

<template>
  <div v-if="!hideToc" class="list-box" :class="openFlag">
    <ul class="list-li-box">
      <li
        class="li content_pagination_button_toc"
        :class="{ 'li--locked': !hasPermission }"
        v-for="(item, idx) in items.filter((content) => content.title !== '')"
        :key="item.id"
        @click="hasPermission && goPage(item.id, idx)"
      >
        {{ item.title }}
      </li>
    </ul>
  </div>
  <div class="list-page-box">
    <IconList v-if="!hideToc && openFlag === ''" @click="openContentsList('open')" />
    <IconClose01 v-if="!hideToc && openFlag === 'open'" @click="openContentsList('')" />
    <span class="no-box content_pagination_area_page">
      <span class="no">{{ formatPageNumber(curPage) }}</span>
      <span> / </span>
      <span class="no">{{ formatPageNumber(totalPages) }}</span>
    </span>
    <IconPrev02 @click="goPage(curPage - 1)" class="content_review_button_prev" :style="disablePrev && curPage <= 1 ? { opacity: 0.3, pointerEvents: 'none' } : {}" />
    <IconNext02 @click="goPage(curPage + 1)" class="content_review_button_next" />
  </div>
</template>
